
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/smart-chains/api/jumblr",
      function () {
        return require("private-next-pages/en/docs/smart-chains/api/jumblr/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/smart-chains/api/jumblr"])
      });
    }
  